// extracted by mini-css-extract-plugin
export var button = "_dz-4";
export var hasDarkBackground = "_dz-7";
export var hasLightBackground = "_dz-6";
export var iconWrapper = "_dz-0";
export var large = "_dz-2";
export var medium = "_dz-1";
export var small = "_dz-5";
export var xsmall = "_dz-3";